<template>
  <el-card class="collapse-group border-primary bg-secondary">
    <el-collapse @change="change" v-model="activeName">
      <div class="group-item">
        <el-collapse-item name="item">
          <template #title>
            <span class="title text-primary">{{ title }}</span>
          </template>
          <slot></slot>
        </el-collapse-item>
      </div>
    </el-collapse>
  </el-card>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'
export default defineComponent({
  name: 'CollapseGroup',
  emits: ['change'],
  props: {
    // 初期でcollapseを開くかどうか
    isOpen: {
      type: Boolean,
      required: false,
      default: false,
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
  },
  setup(props, context) {
    const activeName = ref<string>('')

    watch(
      () => props.isOpen,
      () => {
        activeName.value = props.isOpen ? 'item' : ''
      },
      { immediate: true }
    )

    return {
      activeName,
      change: () => {
        context.emit('change')
      },
    }
  },
})
</script>

<style scoped lang="scss">
.el-collapse {
  border-top: initial;
  border-bottom: initial;
}

.group-item {
  ::v-deep(.el-collapse-item__header) {
    font-weight: bold;
    border-bottom: initial;
    font-size: 1.25em;
    padding-bottom: 0px;
  }
  ::v-deep(.el-collapse-item__wrap) {
    background-color: #f2f2e7 !important;
    border-bottom: initial;
  }
  ::v-deep(.el-collapse-item__header) {
    background-color: #f2f2e7 !important;
  }
  ::v-deep(.el-collapse-item__content) {
    padding-bottom: 0px;
  }
}
</style>
